<template>
  <div>
    <form-radio-group label="Loại" :model="initContactModel" attribute="type" :options="[
                {value: 'customer', text: 'Khách hàng'},
                // {value: 'ticket', text: 'Ticket'},
                // {value: 'call-campaign-contact', text: 'Liên hệ chiến dịch gọi'},
          ]" :errors="formErrors"></form-radio-group>

    <div class="row">
      <form-input class="col-md" :model="initContactModel" attribute="domain" :errors="formErrors"
                  placeholder="Domain"/>

      <div class="col-md">
        <button class="btn btn-primary mr-1 mb-1" @click="initContact"
                :disabled="!initContactModel.domain || !initContactModel.type">
          Bắt đầu Index
        </button>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data: function () {
    return {
      initContactModel: {
        domain: null,
        type: 'customer',
      },
      formErrors: []
    }
  },
  methods: {
    initContact() {
      let loader = this.$loading.show();
      this.$service({url: '/tool/index-search', method: 'post', data: this.initContactModel}).then(response => {
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t('indexSuccess'),
            icon: 'success'
          });
          this.initContactModel.domain = null;
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t('indexFailed'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        loader.hide();
      });
    }
  },
  i18n: {
    messages: {
      en: {
        indexSuccess: "Indexing was successful",
        indexFailed: "Indexing failed",
      },
      vi: {
        indexSuccess: "Index thành công",
        indexFailed: "Index thất bại",
      }
    }
  }
}
</script>